import React from 'react';
import { Box, Button } from '@mui/material';

const RecipeFormButtons = ({ isEditMode, onCancel, onSubmit, disabled }) => {
  return (
    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
      <Button variant="outlined" onClick={onCancel}>
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={onSubmit}
        disabled={disabled}
      >
        {isEditMode ? 'Save Changes' : 'Save Recipe'}
      </Button>
    </Box>
  );
};

export default RecipeFormButtons; 